export default __webpack_public_path__ + "static/media/faq_1_img_1.4898c31a.svg";